import flatpickr from 'flatpickr';

export default function initFlatpickr() {
  const datepickers = document.querySelectorAll('[data-flatpickr]');

  datepickers.forEach((el) => {
    const options = el.dataset.flatpickr ? JSON.parse(el.dataset.flatpickr) : {};

    flatpickr(el, options);
  });
}
